import AbstractGuestlistDetailsPageController from '../abstract-details-controller';
import askForLeavingWithoutSavingChanges
    from '../../../../../../modules/core/helpers/routing/ask-for-leaving-without-saving-changes';
import ticketTemplateModelReducer
    from '../../../../../../modules/tickets/templates/reducers/ticket-template-model-reducer';

export default class GuestlistPdfTicketPageController extends AbstractGuestlistDetailsPageController {

    constructor($scope, $injector) {
        super($scope, $injector);

        this.originalTemplate = null;
        this.originalModel = null;
        this.model = null;
        this.dataChanged = false;
        this.submitting = false;

        askForLeavingWithoutSavingChanges(this);
    }

    discardChanges() {
        this.model = _.cloneDeep(this.originalModel);
        this._reloadEditor();
    }

    save() {
        this.submitting = true;
        this.api
            .put(
                `tickets/templates/${this.guestlist.ticket_template_id}`,
                this.model
            )
            .then(({data}) => {
                this.submitting = false;

                this.originalTemplate = data.data;
                this.originalModel = ticketTemplateModelReducer(this.originalTemplate);
                this.model = _.cloneDeep(this.originalModel);

                this._reloadEditor();
            })
            .catch(() => {
                this.submitting = false;
            })
    }

    _reloadEditor() {
        this.loading = true;
        this.injector.get('$timeout')(
            () => {
                this.loading = false;
            },
            10
        )
    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();

        if (!this.guestlist.ticket_template_id) {
            return;
        }

        this.loading = true;

        this.api
            .get(`tickets/templates/${this.guestlist.ticket_template_id}`)
            .then(({data}) => {
                this.originalTemplate = data.data;
                this.originalModel = ticketTemplateModelReducer(this.originalTemplate);
                this.model = _.cloneDeep(this.originalModel);

                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            })
    }

    _initWatchers() {
        super._initWatchers();

        this.scope.$watch(
            () => this.model,
            () => {
                this.allowRoute = _.isEqual(this.model, this.originalModel);
                this.dataChanged = !this.allowRoute;
            },
            true
        );
    }

    handleModelChange(model) {
        this.model = _.cloneDeep(model);
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/guestlists/tickets/pdf-ticket-controller.js